// extracted by mini-css-extract-plugin
module.exports = {"stripeSectors":"global-module--stripeSectors--2ek0r"};